<template>
	<div>
		<OnboardingModal
			v-if="showOnboardingModal"
			:isLaptop="!isMobile"
			:onboardingGateReady="isOnboardingGateReady()"
			@open-upload-resume="handleOpenUploadResume"
			@close-modal="handleOnboardingModalClose"
		/>
		<UploadResume
			v-if="showUploadResumeModal"
			:showModal="showUploadResumeModal"
			:isLaptop="!isMobile"
			:showBackToOnboarding="showUploadBackToOnboarding"
			@open-fill-form="handleUploadOpenFillForm"
			@getCandidateDetail="handleUploadCandidateDetail"
			@upload-parse-complete="handleUploadParseComplete"
			@upload-modal-closed="handleUploadModalClosed"
			@back-to-onboarding="handleBackToOnboardingFromUpload"
		/>
		<PersonalDetailsModal
			v-if="showPersonalDetailsModal"
			:showModal="showPersonalDetailsModal"
			:form="selectedPersonalDetailsForm"
			:formType="personalDetailsModalType"
			@close-modal="handlePersonalDetailsModalClose"
			@update-data="handlePersonalDetailsUpdated"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import OnboardingModal from "@/components/Home/OnboardingModal.vue";
import UploadResume from "@/components/BuilderPage/UploadResume.vue";
import PersonalDetailsModal from "@/components/BuilderPage/PersonalDetailsModal.vue";
import commonFunc from "@/components/mixin/commonFunction.js";
import onboardingMixin from "@/components/mixin/Onboarding.js";
import EventBus from "@/utils/EventBus.js";

export default {
	name: "GlobalOnboardingFlow",
	props: {
		appBootstrapped: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		OnboardingModal,
		UploadResume,
		PersonalDetailsModal,
	},
	mixins: [commonFunc, onboardingMixin],
	data() {
		return {
			windowWidth: window.innerWidth,
			isRouteResolved: false,
		};
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getPrimaryCandidateInfo",
		}),
		isMobile() {
			return this.windowWidth <= 1028;
		},
	},
	mounted() {
		window.addEventListener("resize", this.onResize);
		this.markRouteResolved();
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.onResize);
	},
	watch: {
		$route() {
			this.markRouteResolved();
		},
		showOnboardingModal(val) { this.updateGlobalOnboardingState(val); },
		showUploadResumeModal(val) { this.updateGlobalOnboardingState(val); },
		showPersonalDetailsModal(val) { this.updateGlobalOnboardingState(val); },
	},
	methods: {
		isOnboardingGateReady() {
			return (
				this.appBootstrapped === true &&
				this.isCandidateHydrated === true &&
				this.isRouteResolved === true
			);
		},
		updateGlobalOnboardingState() {
			const isActive = !!(this.showOnboardingModal || this.showUploadResumeModal || this.showPersonalDetailsModal);
			this.$store.commit("candidateVUEX/setOnboardingActive", isActive);
		},
		markRouteResolved() {
			this.isRouteResolved = false;
			this.$nextTick(() => {
				this.isRouteResolved = true;
				if (!this.$store.state.candidateVUEX.isOnboardingActive) {
					this.chkOnboardingRequirement(this.candidateInfo);
				}
			});
		},
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		async handleOnboardingModalClose() {
			this.showOnboardingModal = false;
			await this.getCandidatePrimaryProfile();
			if (this.candidateData && this.candidateData._id) {
				await this.profileCompletion(this.candidateData);
				EventBus.$emit("update-data", { formID: "personalDetails" });
			}
			if (this.$route?.query?.roadmapSkills) {
				EventBus.$emit("roadmap-onboarding-closed");
			}
		}
	},
};
</script>